import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { Build } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

export type TestFailuresResponse = {
  failures: Array<{
    id: string;
    testName: string;
    scope: string;
    failureReason: string;
    failureExpanded: Array<{
      backtrace?: string[];
      expanded?: string[];
    }> | null;
  }>;
};

export const testFailuresQueryKey = (buildId: string, jobId: string) => {
  return ["build", buildId, "jobs", jobId, "testFailures"];
};

export const testFailuresQueryOptions = (
  build: Build,
  jobId: string,
  queryOptionsArgs: Omit<UseQueryOptions<TestFailuresResponse>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: testFailuresQueryKey(build.id, jobId),
    queryFn: ({ signal }) => fetchTestFailures(build, jobId, signal),
    staleTime: Infinity,
    retry: false,
    ...queryOptionsArgs,
  });
};

async function fetchTestFailures(
  build: Build,
  jobId: string,
  signal: AbortSignal,
): Promise<TestFailuresResponse> {
  const url = new URL(
    `/organizations/${build.account.slug}/analytics/builds/${build.id}/jobs/${jobId}/test_failures`,
    window.location.origin,
  );

  return fetcher<TestFailuresResponse>(url, true, { signal });
}
